//------------------------------------------------------------------------------
// name: fund.ts
// author: mudas
// created: 2025/12/03
//------------------------------------------------------------------------------

import { Platform, WithdrawStatus, WithdrawChannel } from 'common/types';

export interface RBAC_TableQuery {
  _page: number;
  _num: number;
  platform?: Platform;
  type?: 'INNER' | 'OUTER';
}

//1任务收入 2.提现 3.退回 4.扣除
export enum ScoreChangeType {
  TASK_INCOME = 1,
  WITHDRAW,
  DRAW_BACK,
  DEDUCTED,
}

export const MapIdToPlatform = {
  1: '标注众包平台',
  2: '绘梦天工平台',
};

export enum TransactionType {
  //充值
  RECHARGE = 1,
  //转账
  TRANSFER = 2,
}
export interface TransactionDetailType {
  name: string;
  taskUrl: string;
  taskId: string;
  internalAllocator: string;
  internalAllocatorPhone: string;
  initialDate: string;
  confirmDate: string;
  payee?: string;
  payeePhone?: string;
  amount: string;
  actualAmount: string;
  taxRate: string;
  serviceRate: string;
}

export type AssetTradeRecord = {
  amount: string;
  time: number;
  orderId: string;
  content: { id: string; name: string; type: string; originalPrice: string; commission: string };
};

// 提现记录
export type FastApiWithdrawRecord = {
  amount: string;
  actualAmount: string;
  taxAmount: string;
  status: WithdrawStatus;
  transactionId: string;
  withdrawChannel: WithdrawChannel; // 提现渠道

  relatedParentTaskId: string; // 关联的父任务id
  relatedParentTaskSubject: string; // 关联的父任务名称
  relatedTasks?: Array<{
    parentTaskId: number;
    taskSubject: string;
  }>; // 关联的任务列表（多任务支持）
  createTime: string;
};

// 充值记录
export type FastApiRechargeRecord = {
  amount: number;
  transactionId: string;
  transactionType: string;
  status: string;
  createTime: string;
  relatedParentTaskId: string; //关联的父任务id
};

export type WithdrawDetail = {
  //个人提现时，自动计算提现明细的类型
  taskSubject: string;
  scoreReceived: string;
  scoreWithdrawLeft: string;
  currentWithdrawAmount: string;
};

export type TaskIncomeRecord = {
  id: string;
  amount: string;
  time: number;
  orderId: string;
  operator: string;
  content: {
    id: string;
    name: string;
    type: number;
    remark: string;
    taxation: string;
    commission: number;
    originalPrice: string;
  };
  platform: Platform;
};

export type TaskExpendRecord = {
  createTime: string;
  type: ScoreChangeType;
  scoreNum: number; //积分数额
  content: {
    id: string;
    name: string;
    type: number;
    remark: string;
    taxation: string;
    commission: number;
    originalPrice: string;
  }; //明细内容
  balance: number; //余额
  deductScore: number; //扣除积分
  deductReason: string; //扣除原因
};
